import React from "react";
import { Container,Typography, Box } from "@mui/material";


const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "#021526",
        color: "white",
        padding: "1rem",
        position: "fixed",
        bottom: 0, 
        width:"100%",
        zIndex: 1000, 
      }}
    >
      
        {/* Footer Bottom */}
        <Box textAlign="center">
          <Typography variant="body2" sx={{ color: "rgba(255, 255, 255, 0.7)"}}>
          © {currentYear} TechRovar IT Private Limited. All Rights Reserved.
          </Typography>
        </Box>
      
    </Box>
  );
};

export default Footer;
